import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getEods: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    const eods = await api.get("eod/report-list");
    if (eods.message === "You are not authorized for this action") {
    //  const eods="null"
    // console.log("avcfdfd")
      return eods.message;
     
    } else {
      await store.update((state) => {
        state.eods = eods;
      });
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const eodActions = {
  getEods,
};
